import React from 'react';
import '../styles/forceModal.css';

function ForceModal({ force, forceInfo, content, onClose }) {
  if (!force) return null;

  const info = forceInfo[force];

  return (
    <div className="force-modal-overlay" onClick={onClose}>
      <div className="force-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button className="force-modal-close" onClick={onClose}>
          ✕
        </button>

        {/* Header with Icon */}
        <div className="force-modal-header">
          <img src={info.icon} alt={info.name} className="force-modal-icon" />
          <h2>{info.name}</h2>
          <p className="force-modal-subtitle">{info.action}</p>
        </div>

        {/* Content */}
        <div className="force-modal-body">
          <p className="force-modal-description">{content}</p>
        </div>

        {/* Close Button (Mobile friendly footer) */}
        <div className="force-modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForceModal;
